/* eslint-disable camelcase */

import React from 'react'

// Local import
import TextField from '../BasicFields/TextField'
import { updateErrors } from '../SectionField'
import TrashCanIcon from '../../ui/icons/TrashCanIcon'
import DuplicateIcon from '../../ui/icons/DuplicateIcon'

class Photos extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: props.question.id,
      context: props.question.context,
      position: props.question.position,
      title: props.question.title,
      mandatory: props.question.mandatory,
      spherical_photo: props.question.spherical_photo || false,
      errors: props.question.errors || {}
    }
  }

  shouldComponentUpdate(_nextProps, nextState) {
    this.state.errors = updateErrors(this.state.errors, this.props.getErrors)

    return (
      this.state.title !== nextState.title ||
      this.state.mandatory !== nextState.mandatory ||
      this.state.spherical_photo !== nextState.spherical_photo ||
      this.state.position !== nextState.position ||
      this.state.errors.isNew === true
    )
  }

  componentDidUpdate() {
    this.props.handleQuestionChange(this.state)
  }

  handleChange = event => this.setState({ [event.target.name]: event.target.value })

  handleMandatoryChange = event => this.setState({ mandatory: event.target.checked })

  handlePhotoTypeChange = event => {
    const spherical_photo = event.target.value === '360'
    this.setState(prevState => ({
      spherical_photo,
      mandatory: spherical_photo ? false : prevState.mandatory
    }))
  }

  render() {
    return (
      <div className="nested-fields ml-2 ml-md-4">
        <div className="d-flex mb-2">
          <div className="d-flex align-items-center mr-auto">
            <i className="fas fa-arrows-alt c-pointer mr-2" {...this.props.dragHandleProps} />
            <span>Question avec photos</span>
            <DuplicateIcon
              className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer ml-2"
              onClick={this.props.handleQuestionDuplicate(this.state.id)}
            />
          </div>
          <TrashCanIcon
            className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
            onClick={this.props.handleQuestionRemove(this.state.id)}
          />
        </div>
        <div className="mb-2">
          <div className="d-flex align-items-center mb-2">
            <label className="mb-0 mr-1">Type de photo</label>
            <i
              className="fas fa-info-circle text-muted"
              title="Choisissez le type de photo pour cette question"
            />
          </div>
          <div className="d-flex">
            <div className="custom-control custom-radio mr-4">
              <input
                type="radio"
                id={`photo-classic-${this.state.id}`}
                name={`photo-type-${this.state.id}`}
                className="custom-control-input"
                value="classic"
                checked={!this.state.spherical_photo}
                onChange={this.handlePhotoTypeChange}
              />
              <label className="custom-control-label" htmlFor={`photo-classic-${this.state.id}`}>
                Photo classique
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id={`photo-360-${this.state.id}`}
                name={`photo-type-${this.state.id}`}
                className="custom-control-input"
                value="360"
                checked={this.state.spherical_photo}
                onChange={this.handlePhotoTypeChange}
              />
              <label className="custom-control-label" htmlFor={`photo-360-${this.state.id}`}>
                Photo 360°
              </label>
            </div>
          </div>
        </div>
        <TextField
          name="title"
          value={this.state.title}
          placeholder="Titre de la question..."
          errors={this.state.errors.title}
          onChange={this.handleChange}
        />
        {!this.state.spherical_photo && (
          <div className="custom-control custom-switch mt-3">
            <input
              id={`mandatory-question-${this.state.id}`}
              type="checkbox"
              className="custom-control-input"
              checked={this.state.mandatory}
              onChange={this.handleMandatoryChange}
            />
            <label className="custom-control-label" htmlFor={`mandatory-question-${this.state.id}`}>
              Réponse obligatoire
            </label>
          </div>
        )}
      </div>
    )
  }
}

export default Photos
